import "./AddWorkstreamAction.scss";

import React from "react";
import { connect } from "react-redux";
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { getData } from "Source/globalFunction";

@connect(store => {
    return {
        workstreams: store.workstreams
    };
})

class AddWorkstreamAction extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null
        }

        _.map(["onClick", "displayUsers","handleClick"], fn => {
            this[fn] = this[fn].bind(this);
        });
        this.add = React.createRef()
    }
    componentDidUpdate(prev){
        if(!_.isEqual(prev.isEdit, this.props.isEdit)){
            if(this.props.isEdit ==='workstream_add') {
                this.setState({...this.state, anchorEl: this.add.current});
            } else {
                this.setState({...this.state, anchorEl:null});
            }
             
        }else if (!_.isEqual(prev.isOpen, this.props.isOpen)){
           
            if(prev.isOpen && prev.isOpen ==='workstream_add') {
              this.setState({...this.state, anchorEl: null});
            }

        }
    }
    onClick(e) {
        e.preventDefault();

        const { dispatch } = this.props;
        
        $(`#addWorkstreamModal`).modal("show");

        dispatch({ type: "UPDATE_WORKSTREAM_FORM_TYPE", formType: "default" });
    }

    displayUsers(e) {
        e.preventDefault();

        const { dispatch } = this.props;
        
        $(`#addWorkstreamModal`).modal("show");

        dispatch({ type: "UPDATE_WORKSTREAM_FORM_TYPE", formType: "fromTemplate" });
    }

     handleClick(event) {
        if(this.props.triggerEdit) {
            this.props.triggerEdit({workstream_add:true})
           
        }
        if(this.props.hasChanges && this.props.hasChanges.length >0) {   
            $('#accountSetting').modal("show")
        } else {
            this.setState({...this.state, anchorEl: event.currentTarget});
            if(this.props.onActions) {
                this.props.onActions(true);
            }
        }
      

        
    }
    render() {
        const open = Boolean(this.state.anchorEl);

      
        
        const handleClose = () => {
            this.setState({...this.state, anchorEl: null});
            if(this.props.onCancel) {
                this.props.onCancel()
            }
            if(this.props.onActions) {
                this.props.onActions(false);
            }
        }

        return (
            <div class="formsHeaderActions workstreamActions">
                <div class="actionItem" >
                    <a ref={this.add} onClick={this.handleClick} class={`${open || this.props.isActive ? "active" : ""}`} >
                        <i class="material-icons mr10">add</i>
                        <span>Add</span>
                    </a>
                    <Popper
                        open={open}
                        anchorEl={this.state.anchorEl}
                        placement="bottom-end"
                        style={{zIndex: 100}}
                    >
                        <ClickAwayListener onClickAway={handleClose}>
                            <div class="actionsContainer workstreamDropdownContainer">
                                <div class="actionItem">
                                    <a onClick={this.onClick}>
                                        <span>New Workstream</span>
                                    </a>
                                </div>
                                <div class="actionItem">
                                    <a onClick={this.displayUsers}>
                                        <span>from an Existing Workstream</span>
                                    </a>
                                </div>
                            </div>
                        </ClickAwayListener>
                    </Popper>
                </div>
            </div>
        );
    }
}

export default AddWorkstreamAction;